import { z } from "zod";
import { baseEntitySchema } from "./base";

// Enum for audit actions
export enum AuditLogAction {
  CREATE = "create",
  UPDATE = "update",
  DELETE = "delete",
}

// Schema for field changes (before/after values)
export const fieldChangeSchema = z.object({
  from: z.any().optional(),
  to: z.any().optional(),
});

// Schema for user information
export const auditLogUserSchema = z.object({
  id: z.string(),
  email: z.string().optional(),
  isAdmin: z.boolean().default(true),
});

// Main audit log data schema
export const auditLogDataSchema = z.object({
  // Action performed
  action: z.nativeEnum(AuditLogAction),

  // Collection and document information
  collection: z.string().min(1),
  documentId: z.string().min(1),

  // User who performed the action
  user: auditLogUserSchema,

  // Field changes (for update operations)
  changes: z.record(z.string(), fieldChangeSchema).optional(),

  deletedData: z.record(z.string(), z.any()).optional(),
  createData: z.record(z.string(), z.any()).optional(),
});

export type AuditLogData = z.infer<typeof auditLogDataSchema>;
export type FieldChange = z.infer<typeof fieldChangeSchema>;
export type AuditLogUserContext = z.infer<typeof auditLogUserSchema>;

// Complete audit log schema with base entity fields
export const auditLogSchema = baseEntitySchema.and(auditLogDataSchema);
export type AuditLog = z.infer<typeof auditLogSchema>;
